const DEFAULT_KEY = "gym:rest-default-seconds";
const OVERRIDE_PREFIX = "gym:rest-override-";

const DEFAULT_SECONDS = 90;

function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore quota/privacy errors
  }
}

function parseSeconds(raw: string | null, fallback: number): number {
  if (raw === null) return fallback;
  const n = Number(raw);
  if (!Number.isInteger(n) || n < 0) return fallback;
  return n;
}

export function loadDefaultSeconds(): number {
  return parseSeconds(safeGet(DEFAULT_KEY), DEFAULT_SECONDS);
}

export function saveDefaultSeconds(seconds: number): void {
  safeSet(DEFAULT_KEY, String(Math.max(0, Math.floor(seconds))));
}

export function loadOverrideSeconds(exerciseId: number): number | null {
  const raw = safeGet(`${OVERRIDE_PREFIX}${exerciseId}`);
  if (raw === null) return null;
  const n = Number(raw);
  return Number.isInteger(n) && n >= 0 ? n : null;
}

export function saveOverrideSeconds(
  exerciseId: number,
  seconds: number | null,
): void {
  const key = `${OVERRIDE_PREFIX}${exerciseId}`;
  if (seconds === null) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // ignore
    }
    return;
  }
  safeSet(key, String(Math.max(0, Math.floor(seconds))));
}

export function effectiveRestSeconds(
  exerciseId: number,
  defaultSeconds: number,
): number {
  const override = loadOverrideSeconds(exerciseId);
  return override ?? defaultSeconds;
}
